import {
  post,
  get
} from "services/BaseClient/Client";
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";





export const getCategoryBasedAdvertCounts = async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
  const url = `${endpoints.getCategoryBasedAdvertCounts}?${query||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url,config);
};

export const  getAdvertDurationStats = async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
  const url = `${endpoints.getAdvertDurationStats}?${query||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url,config);
};

export const  getAdvertDuration30Day = async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
  const url = `${endpoints.getAdvertDuration30Day}?${query||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url,config);
};

export const  getMessageResponseTime = async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
  const url = `${endpoints.getMessageResponseTime}?${query||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url,config);
};

export const  getUnansweredMessages= async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
  const url = `${endpoints.getUnansweredMessages}?${query||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url,config);
};




